import React from 'react';
import { createPortal } from 'react-dom';
import style from './index.module.scss';
import { useLang } from '@/i18n';

interface Props {
    onClose: () => void;
    open: boolean;
}

const Dialog: React.FC<Props> = ({ onClose, open }) => {
    const { t } = useLang('powerBank.EarlyBird');
    if (!open) return null;
    return createPortal(
        <div className={style.comp}>
            <div className="mask"></div>
            <div className="body">
                <div className="close" onClick={onClose}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <circle cx="10" cy="10" r="10" fill="black" fillOpacity="0.4" />
                        <path
                            d="M12.1262 6.46958C12.4191 6.17687 12.8939 6.17675 13.1867 6.46958C13.4794 6.76242 13.4794 7.23728 13.1867 7.53012L10.8879 9.82798L13.1867 12.1268C13.4796 12.4197 13.4796 12.8945 13.1867 13.1874C12.8938 13.4799 12.419 13.4801 12.1262 13.1874L9.82736 10.8885L7.52951 13.1874C7.23667 13.48 6.76181 13.48 6.46897 13.1874C6.17614 12.8945 6.17626 12.4197 6.46897 12.1268L8.76682 9.82798L6.46994 7.53012C6.17705 7.23723 6.17705 6.76247 6.46994 6.46958C6.76285 6.17687 7.23766 6.17675 7.53049 6.46958L9.82736 8.76743L12.1262 6.46958Z"
                            fill="white"
                        />
                    </svg>
                </div>
                <div className="title">{t('modal_title')}</div>
                <ul>
                    <li>{t('modal_item1')}</li>
                    <li>{t('modal_item2')}</li>
                </ul>
            </div>
        </div>,
        document.body,
    );
};
export default Dialog;
